import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => <Outlet />,
  // 未匹配的前台路径统一回首页
  notFoundComponent: () => {
    throw redirect({ to: '/' });
  },
});
